import { useState } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { usePermissions } from '@/hooks/usePermissions'

interface ConfirmarBienvenidaDialogProps {
  open: boolean
  email: string
  onConfirmar: (adjuntarEstadoCuenta: boolean) => void
  onCancelar: () => void
}

/**
 * Pregunta, al terminar el alta, si se manda la bienvenida al email del cliente.
 * El contrato va siempre; el estado de cuenta se puede destildar, y sin `enviarEstadoCuenta` o sin
 * `verHonorariosCliente` no se ofrece. No se cierra por click afuera.
 */
export function ConfirmarBienvenidaDialog({ open, email, onConfirmar, onCancelar }: ConfirmarBienvenidaDialogProps) {
  const { puede } = usePermissions()
  const puedeAdjuntarEstadoCuenta = puede.enviarEstadoCuenta && puede.verMovimientos
  const [adjuntarEstadoCuenta, setAdjuntarEstadoCuenta] = useState(true)

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Enviar la bienvenida al cliente?</AlertDialogTitle>
          <AlertDialogDescription>
            Se envía el contrato a <strong>{email}</strong>.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {puedeAdjuntarEstadoCuenta && (
          <div className="flex items-center gap-2">
            <Checkbox
              id="adjuntar-estado-cuenta"
              checked={adjuntarEstadoCuenta}
              onCheckedChange={(valor) => setAdjuntarEstadoCuenta(valor === true)}
            />
            <Label htmlFor="adjuntar-estado-cuenta">Adjuntar estado de cuenta</Label>
          </div>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancelar}>No enviar ahora</AlertDialogCancel>
          <AlertDialogAction onClick={() => onConfirmar(adjuntarEstadoCuenta && puedeAdjuntarEstadoCuenta)}>
            Enviar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
